import React from "react";
import * as S from "./styles.common";

const ResultsRow = ({ children }) => {
  return <S.ResultsRow>{children}</S.ResultsRow>;
};

export default ResultsRow;
